// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyColumnsList_container__33Ej7","title":"EmptyColumnsList_title__3_Ku1","textWithIcon":"EmptyColumnsList_textWithIcon__1JJgl"};